export default __webpack_public_path__ + "static/media/nectar black.db25379c.svg";